export default __webpack_public_path__ + "static/media/wel1.d415c22a.png";